import { jsxs, jsx } from "react/jsx-runtime";
const ReadOnly = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20.2678 3.73223L20.7981 3.2019L20.7981 3.2019L20.2678 3.73223ZM6.50006 21.0355V21.7855C6.69897 21.7855 6.88974 21.7065 7.03039 21.5658L6.50006 21.0355ZM3.00006 21.0355H2.25006C2.25006 21.4497 2.58585 21.7855 3.00006 21.7855V21.0355ZM3.00006 17.4644L2.46973 16.9341C2.32908 17.0747 2.25006 17.2655 2.25006 17.4644H3.00006ZM8.03033 13.4948C8.32322 13.2019 8.32322 12.727 8.03033 12.4341C7.73744 12.1412 7.26256 12.1412 6.96967 12.4341L8.03033 13.4948ZM11.5659 17.0303C11.8588 16.7374 11.8588 16.2626 11.5659 15.9697C11.273 15.6768 10.7981 15.6768 10.5052 15.9697L11.5659 17.0303ZM17.2626 4.26256C17.946 3.57915 19.054 3.57915 19.7374 4.26256L20.7981 3.2019C19.5289 1.9327 17.4711 1.9327 16.2019 3.2019L17.2626 4.26256ZM19.7374 4.26256C20.4209 4.94598 20.4209 6.05402 19.7374 6.73744L20.7981 7.7981C22.0673 6.52889 22.0673 4.47111 20.7981 3.2019L19.7374 4.26256ZM6.50006 20.2855H3.00006V21.7855H6.50006V20.2855ZM2.25006 17.4644V21.0355H3.75006V17.4644H2.25006ZM14.7019 5.76256L18.2374 9.2981L19.2981 8.23744L15.7626 4.7019L14.7019 5.76256ZM6.96967 12.4341L2.46973 16.9341L3.53039 17.9947L8.03033 13.4948L6.96967 12.4341ZM10.5052 15.9697L5.96973 20.5051L7.03039 21.5658L11.5659 17.0303L10.5052 15.9697ZM16.2019 3.2019L9.96967 9.43414L11.0303 10.4948L17.2626 4.26256L16.2019 3.2019ZM19.7374 6.73744L13.4697 13.0052L14.5303 14.0659L20.7981 7.7981L19.7374 6.73744Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M3 3L6.58916 6.58916L9.87868 9.87868L14.1213 14.1213L17.4112 17.4112L21 21",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
};
export {
  ReadOnly as default
};
